@if (confirmarCancelamento === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img src="/assets/img/fazer-pedido.png" width="70px" alt="">
      <h3 class="subtitulo-alert mt-3 mb-1">Deseja cancelar os pedidos selecionados?</h3>
      <div class="d-flex justify-content-center mt-3">
        <button class="botao me-3" id="btnConfirmar" (click)="fecharAlertConfirmacao('Confirmar')">CONFIRMAR</button>
        <button class="botao-outline" id="btnVoltar" (click)="fecharAlertConfirmacao('Fechar')">VOLTAR</button>
      </div>
    </div>
  </div>
}
